export default {"src":"/_next/static/media/wheat.effb5a24.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};